import type { V2 } from '../core/math';
import type { Body } from '../physics/body';
import { makeTelemetry } from './model';
import type {
  Occupant,
  Vehicle,
  VehicleController,
  VehicleControls,
  VehicleDamage,
  VehicleSpec,
  VehicleTelemetry,
  VehicleCondition,
} from './types';

export class VehicleEntity implements Vehicle {
  controls: VehicleControls = { throttle: 0, steer: 0, handbrake: false };
  controller: VehicleController = 'none';
  occupant: Occupant | null = null;
  ownedByPlayer = false;
  stolen = false;
  locked = false;
  health: number;
  damage: VehicleDamage = { front: 0, rear: 0, left: 0, right: 0 };
  punctures = { left: 0, right: 0 };
  destroyed = false;
  condition: VehicleCondition = 'ok';
  fireTimer = 0;
  /** Increments whenever damage changes (views re-deform the mesh lazily). */
  damageVersion = 0;
  /** World-space impact points (local coords) used by the view to crumple panels. */
  dents: { x: number; z: number; depth: number }[] = [];
  siren = false;
  headlights = true;
  paint: number;
  telemetry: VehicleTelemetry = makeTelemetry();
  tags = new Set<string>();
  data: Record<string, unknown> = {};
  /** Sim time of the last collision caused while the player was driving / hit by player car. */
  lastPlayerHitTime = -Infinity;

  constructor(
    readonly id: number,
    readonly spec: VehicleSpec,
    readonly body: Body,
    readonly isPolice: boolean,
    paint: number,
  ) {
    this.health = spec.maxHealth;
    this.paint = paint;
  }

  get pos(): V2 {
    return this.body.pos;
  }
  get heading(): number {
    return this.body.angle;
  }
  get velocity(): V2 {
    return this.body.vel;
  }
  get speed(): number {
    return this.body.speed();
  }
}
